import { createStore } from 'vuex'

const store = createStore({
  state: {
    loggedIn: false,
    username: '',
    accessToken: '',
    pid: '',  // process id for logging relation in the BE
    appMode: 'Live',
    permissions: [] as string[],  // 'component:action' strings
    mustChangePassword: false,
    user: null as any,
  },
  getters: {
    isLoggedIn(state) {
      return state.loggedIn
    },
    getUsername(state) {
      return state.username
    },
    getAccessToken(state) {
      return state.accessToken
    },
    getPid(state) {
      return state.pid
    },
    getAppMode(state) {
      return state.appMode
    },
    getPermissions(state) {
      return state.permissions
    },
    getMustChangePassword(state) {
      return state.mustChangePassword
    },
    getUser(state) {
      return state.user
    },
    // Usage: store.getters.can('users', 'read')
    can(state) {
      return (component: string, action: string) =>
        state.permissions.includes(`${component}:${action}`)
    },
  },
  mutations: {
  },
  actions: {
    setLoggedIn(context, loggedIn) {
      context.state.loggedIn = loggedIn
    },
    setUsername(context, username) {
      context.state.username = username
    },
    setAccessToken(context, accessToken) {
      context.state.accessToken = accessToken
    },
    setPid(context, pid) {
      context.state.pid = pid
    },
    setAppMode(context, appMode) {
      context.state.appMode = appMode
    },
    setPermissions(context, permissions) {
      context.state.permissions = permissions || []
    },
    setMustChangePassword(context, mustChangePassword) {
      context.state.mustChangePassword = !!mustChangePassword
    },
    setUser(context, user) {
      context.state.user = user
    },

    logOut(context) {
      context.state.loggedIn = false
      context.state.username = ''
      context.state.accessToken = ''
      context.state.permissions = []
      context.state.mustChangePassword = false
      context.state.user = null
    },
  },
  modules: {
  }
})

export default store